import React, { useEffect, useState } from "react";
import axios from "axios";
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

const COLORS = ["#2563eb", "#22c55e", "#facc15", "#ef4444", "#a855f7", "#0ea5e9"];

const ProjectStats = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get("/project")
      .then((res) => {
        const data = res.data;
        console.log("Fetched projects:", data);

        setProjects(data.filter((p) => p.deletedAt === null));
      })
      .catch((err) => console.error("Erreur de récupération des projets", err));
  }, []);

  const groupBy = (key) => {
    const result = {};
    projects.forEach((p) => {
      const value = p[key];
      if (value) result[value] = (result[value] || 0) + 1;
    });
    return Object.entries(result).map(([name, value]) => ({ name, value }));
  };

  const groupByTechnology = () => {
    const result = {};
    projects.forEach((p) => {
      if (Array.isArray(p.technologies)) {
        p.technologies.forEach((tech) => {
          if (tech?.name) {
            result[tech.name] = (result[tech.name] || 0) + 1;
          }
        });
      }
    });
    return Object.entries(result).map(([name, value]) => ({ name, value }));
  };

  const groupByClient = () => {
    const result = {};
    projects.forEach((p) => {
      const clientName = p.client?.name || "Inconnu";
      result[clientName] = (result[clientName] || 0) + 1;
    });
    return Object.entries(result).map(([name, value]) => ({ name, value }));
  };

  const renderLabel = ({ name, percent }) => {
    if (percent === undefined) return name;
    return `${name} (${(percent * 100).toFixed(0)}%)`;
  };

  return (
  <>
    {/* Conteneur des 4 charts */}
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {[
        { title: "État", data: groupBy("state") },
        { title: "Type de service", data: groupBy("serviceType") },
      ].map((chart, i) => (
        <div
          key={i}
          style={{
            flex: "0 0 calc(50% - 24px)",
    flexWrap: "wrap",
          }}
        >

          <div style={{ width: "100%", height: "280px" }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chart.data}
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  dataKey="value"
                  label={renderLabel}
                >
                  {chart.data.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      ))}
    </div>
  </>
);

};

export default ProjectStats;
